<template>

  <b-col cols="12">

    <b-row>

      <b-col class="d-flex flex-lg-column">

        <div class="main-card card p-2 h-100-header" id="container_pages">

          <div class="card-body" id="card-page">

            <b-row v-if="goBackTo !== ''">

              <router-link class="ml-3 text-secondary"
                           :to="{ name: goBackTo, query: checkLastQuery()}">
                <b-icon-arrow-left-circle class="mr-1"></b-icon-arrow-left-circle>
                {{ goBackTitle }}
              </router-link>

            </b-row>

            <b-row v-else-if="localGoBackPath !== ''">

              <router-link class="ml-3 text-secondary"
                           :to="{ path: localGoBackPath, query: checkLastQuery()}">
                <b-icon-arrow-left-circle class="mr-1"></b-icon-arrow-left-circle>
                {{ goBackTitle }}
              </router-link>

            </b-row>

            <b-row v-else-if="breadcrumb">
              <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            </b-row>

            <b-modal v-model="hasGeneralErrors" id="modalGeneralErrors" title="Erros encontrados:" ok-only>

              <div v-for="error in generalErrors" :key="error" class="p-2 border-bottom mb-2">
                <span class="text-danger">
                  <b-icon-x-circle-fill class="mr-2"/>
                  <span v-html="error.replace(/\n/g,'<br />')"></span>
                </span>
              </div>


              <template #modal-footer="{ ok }">

                <t-button @click="ok()" text="Corrigir Erros" danger/>

              </template>


              <!--                  <div v-if="generalErrors.length > 0" aria-labelledby="swal2-title" aria-describedby="swal2-content"
                                     class="swal2-popup swal2-modal swal2-show" tabindex="-1" style="display: flex; padding: 0px">
                                  <div class="swal2-header" style="scale:0.7">
                                    <ul class="swal2-progresssteps" style="display: none;"></ul>
                                    <div class="swal2-icon swal2-error swal2-animate-error-icon" style="display: flex;"><span
                                        class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span
                                        class="swal2-x-mark-line-right"></span></span></div>
                                    <div class="swal2-icon swal2-success" style="display: none;">
                                      <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                                      <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
                                      <div class="swal2-success-ring"></div>
                                      <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                                      <div class="swal2-success-circular-line-right"
                                           style="background-color: rgb(255, 255, 255);"></div>
                                    </div>
                                    <img class="swal2-image" style="display: none;">
                                    <h2 class="swal2-title" id="swal2-title" style="display: flex;">Corrija o seguintes erros antes de continuar:</h2>


                                  </div>


                                </div>-->

            </b-modal>


            <transition mode="out-in"
                        enter-active-class="animated fadeIn">

              <div v-show="!busy">


                <transition mode="out-in"
                            enter-active-class="animated fadeIn">


                  <div>

                    <t-page-title v-if="title !== ''" :title="title">
                      <slot name="title-buttons"></slot>
                      <t-button class="ml-2" v-if="onSubmitText && onSubmitText.length > 0 && !submitBottom"
                                :text="onSubmitText"
                                :is-invalid="isInvalid && status === 'subject'" :sending="onSending" @click="onSubmit()"
                                :primary="isButtonPrimary" :danger="!isButtonPrimary" submit submit-fake/>
                    </t-page-title>

                    <slot name="header"></slot>

                    <div v-if="tabs">

                      <b-row>

                        <b-col :class="localClassTab">

                          <b-tabs :id="idTab" @activate-tab="checkValidateTabs" v-model="tabIndex" ref="containerTabs"
                                  content-class="mt-3" class="tabs-form" align="left">

                            <!--------------DUPLICAÇÃO PARA EVITAR COMPLEXIDADE----------------->
                            <validation-observer ref="validation" v-slot="{invalid,errors}">
                          <span class="display-none">
                            {{ errorList = errors }}
                            {{ isInvalid = invalid }}
                          </span>
                              <form @submit.prevent="onSubmit" class="fadeIn">

                                <b-card :class="{'mode-card':card,'mode-tabs':!card}">

                                  <t-form-wrapped :command="command" :status="localStatus">

                                    <slot :status="localStatus" ref="content-inner-form" :isInvalid="isInvalid"
                                          :errors="errorList"></slot>


                                  </t-form-wrapped>
                                </b-card>
                              </form>
                            </validation-observer>

                            <slot name="out-of-form"></slot>
                            <!------------------------------------------------------------------->

                          </b-tabs>

                        </b-col>

                        <slot name="after-tabs"></slot>

                      </b-row>


                    </div>


                    <div v-else>

                      <!--------------DUPLICAÇÃO PARA EVITAR COMPLEXIDADE----------------->
                      <validation-observer ref="validation" v-slot="{invalid,errors}">
                          <span class="display-none">
                            {{ errorList = errors }}
                            {{ isInvalid = invalid }}
                          </span>
                        <form @submit.prevent="onSubmit" class="fadeIn">

                          <div v-if="multiCards" class="pl-2 pr-2 pt-0 mt-0">

                            <t-form-wrapped :command="command" :status="localStatus">
                              <slot :status="localStatus" :isInvalid="isInvalid" :errors="errorList"></slot>
                            </t-form-wrapped>

                          </div>

                          <b-card
                              v-else
                              :class="{'mode-card':card,'mode-tabs':!card}">

                            <t-form-wrapped :command="command" :status="localStatus">

                              <slot :status="localStatus" ref="content-inner-form" :isInvalid="isInvalid"
                                    :errors="errorList"></slot>

                            </t-form-wrapped>
                          </b-card>

                        </form>
                      </validation-observer>

                      <slot name="out-of-form"></slot>
                      <!------------------------------------------------------------------->

                    </div>


                    <div v-if="$slots.footer || (onSubmitText && submitBottom) || (onSubmitText && submitTopAndBottom)"
                         class="clearfix border border-top-0 p-3 mb-3 page-form-footer d-flex"
                         :class="{'multi-cards-footer':multiCards}"
                         style="background-color: #f8f8f8; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; border-top-left-radius: 0px;border-top-right-radius: 0px;margin-top: -3px;"
                         id="form-footer-buttons">

                      <t-button v-if="onSubmitText && onSubmitText.length > 0 && (submitBottom || submitTopAndBottom)"
                                :text="onSubmitText"
                                :is-invalid="isInvalid && status === 'subject'" :sending="onSending" submit submit-fake
                                :primary="isButtonPrimary" :danger="!isButtonPrimary" @click="onSubmit()"/>

                      <slot name="footer"></slot>

                    </div>

                  </div>


                </transition>


              </div>
            </transition>


            <div class="container_loading_form" v-show="busy">

              <div class="container_loading_form_card">

                <div class="container-title-page" v-if="title !==''">
                  <div class="gradient flex-grow-1 title-page">
                    <div class="gradient element-80" style="height: 24px;"></div>
                  </div>
                </div>


                <div class="gradient element-60" style="height: 200px;"></div>

                <div class="gradient element-80"></div>


                <div class="gradient element-80"></div>

              </div>


            </div>


          </div>

        </div>

      </b-col>

      <b-col class="col-2 d-none d-xxl-block border-left" v-if="panel">
        Painel Auxiliar para informações rápidas como últimos pedidos do cliente, e informações de inteligência
      </b-col>

    </b-row>

  </b-col>


</template>
<script>
import ui from "@/assets/scripts/ui"

export default {
  name: 't-page-form',
  data() {
    return {
      hasGeneralErrors: false,
      localStatus: "",
      localGoBackPath: "",
      errorList: [],
      isInvalid: false,
      tabIndex: 0,
      localClassTab: "",
    }
  },
  props: {
    status: String,
    submitExternal: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    submitText: String,
    submitTextNotDefault: {//Texto submit fora do padrão, por tanto não irá utilizar o command para composição.
      type: Boolean,
      default: false
    },
    multiCards: Boolean,
    submitTopAndBottom: Boolean,
    submitBottom: {
      type: Boolean,
      default: false
    },
    insertGeneralFieldsAfterPositionInput: {
      type: Number,
      default: 0,
    },
    checkErrorsAgain: Boolean,
    idTab: {
      type: String,
      default: ""
    },
    classTab: {},
    busy: {
      type: Boolean,
      default: false,
    },
    generalErrors: Array,
    goBackTitle: String,
    goBackTo: {//Retorna pelo nome da página
      type: String,
      default: "",
    },
    goBackPath: {//Retorno pelo path da página
      type: String,
      default: "",
    },
    panel: {
      type: Boolean,
      default: false
    },
    breadcrumb: Array,
    url: String,
    tabs: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Boolean,
      default: false
    },
    command: {
      type: String,
      default: 'insert'
    },
    name: {
      type: String,
      default: 'formDefault'
    },
    setTabIndex: {
      type: Number,
      default: 0,
    }

  },
  computed: {

    onSending() {
      return this.status === "sending"
    },
    onSubmitText() {
      if (this.command === 'view') {
        return ''
      } else {

        if (this.command !== '' && !this.submitTextNotDefault) {
          return this.t(this.command) + ' ' + this.submitText
        } else {
          return this.submitText
        }
      }
    },
    isButtonPrimary() {
      return this.command !== 'delete';
    },
    getLastPage() {
      return this.$store.getters.getLastPage
    }

  },
  watch: {

    busy(value) {

      if (!value)
        this.setTabByHash()

    },

    setTabIndex(value) {
      this.tabIndex = value
    },

    submitExternal(value) {

      if (value === 'submit') {
        this.onSubmit()
      }

    },

    //Resposta obtida pelo backend informando da alteração
    checkErrorsAgain(value) {

      if (value && this.tabs) {

        const tabsList = this.$refs.containerTabs._data.tabs

        for (let i = 0; i < tabsList.length; i++) {

          setTimeout(() => {

            //Verifica somente em tabs que possuem campos e não componentes adicionais evitando sobrecarga no carregamento
            if (tabsList[i].$children !== null && tabsList[i].$children.length > 0) {

              this.tabIndex = i

              if (i === tabsList.length - 1) {

                setTimeout(() => {
                  //Somente agora após atualização geral é chamada a função de verificação e irá setar a primeira tab com erro
                  this.checkErrorsTabs()
                }, 200)

              }

            }


          }, (50 * (i + 1)))


        }

      }

    },

    status(value) {
      this.localStatus = value
    },

    goBackPath(value) {
      this.setGoBackPath(value)
    },


    errorList() {

      if (this.isInvalid && this.tabs && this.localStatus === 'subject') {
        this.checkTab(this.tabIndex)
      }

    },

    isInvalid() {
      if (this.tabs && this.localStatus === 'subject')
        this.checkTab(this.tabIndex)
    },

    generalErrors() {
      this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    },


  },
  mounted() {

    if (this.classTab === undefined || this.classTab === null) {
      this.localClassTab = {'col-12': true}
    } else {
      this.localClassTab = this.classTab
    }

    this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    this.localStatus = this.status
    this.setGoBackPath(this.goBackPath)
    this.setTabByHash()


  },
  methods: {

    setTabByHash() {

      if (!this.busy) {

        let hash = window.location.hash

        if (hash !== undefined && hash !== null && hash !== '') {

          hash = hash.replace("#", "")

          if(this.tabs){

            setTimeout(() => {

              const tabsList = this.$refs.containerTabs._data.tabs

              for (let i = 0; i < tabsList.length; i++) {

                const tabId = tabsList[i]._props.id

                if (tabId !== undefined && tabId !== null && tabId !== '') {

                  if (tabId === hash)
                    this.tabIndex = i

                }

              }

            }, 100)


          }



        }

      }


    },

    setGoBackPath(path) {

      let p = path

      if (p.substring(1, 1) !== '/') {
        //Coloca uma barra no início
        p = "/" + p
      }

      if (p.substring(p.length - 1) === '/') {
        //Retira a barra final
        p = p.substring(0, p.length - 1)
      }

      this.localGoBackPath = p
    },

    checkLastQuery() {

      if (this.goBackTo !== '') {
        return this.goBackTo === this.getLastPage.name ? this.getLastPage.query : null
      } else if (this.localGoBackPath !== '') {
        return this.localGoBackPath === this.getLastPage.path ? this.getLastPage.query : null
      }

    },

    async checkErrorsTabs() {

      let setFirstTabError = false
      const tabsList = this.$refs.containerTabs._data.tabs

      for (let i = 0; i < tabsList.length; i++) {

        if (tabsList[i].$children !== null && tabsList[i].$children.length > 0) {

          //Checa somente em tabs que possuem inputs filhos e não aquelas de que possuem um formulario interno, evitando sobrecarregamento

          const isError = this.checkTab(i)

          if (!setFirstTabError && isError) {
            setFirstTabError = true
            this.tabIndex = i
          }
        }

      }

    },

    checkValidateTabs(newTabIndex, prevTabIndex) {
      if (this.status === 'subject') {
        this.checkTab(prevTabIndex)
      }
    },

    checkTab(index) {

      const navTab = this.$refs.containerTabs.$refs.nav.children[index]
      const contentTab = this.$refs.containerTabs._data.tabs[index].$el.getElementsByClassName('is-invalid')
      let isError = false


      //Valores padrões (não possui erro)
      navTab.getElementsByClassName('container-error-tab').item(0).classList.add('not-error')
      navTab.getElementsByClassName('title-tab-normal').item(0).classList.add('not-error')
      navTab.getElementsByClassName('nav-link').item(0).classList.remove('nav-has-error')

      if (contentTab && contentTab.length > 0) {

        isError = true

        //console.log('Possui erros na tab '+i)
        navTab.getElementsByClassName('container-error-tab').item(0).classList.remove('not-error')
        navTab.getElementsByClassName('title-tab-normal').item(0).classList.remove('not-error')
        navTab.getElementsByClassName('nav-link').item(0).classList.add('nav-has-error')

        //let a = this.$refs.containerTabs.$slots.default[i]
        //console.log(a)

      }

      return isError


    },

    async onSubmit() {


      //Avisa o pai que mudou o status para submetido
      this.localStatus = "subject"


      if (this.command === 'delete') {

        if (this.tabs) {
          await this.checkErrorsTabs()
        }

        ui.msgConfirmDelete(this, () => {
          this.$emit('onSubmit')
        })


      } else {

        this.$refs.validation.validate().then(async success => {

          if (this.tabs) {
            await this.checkErrorsTabs()
          }

          if (success) {
            this.$emit('onSubmit')
          } else {
            ui.msgErrorForm(this, this.$refs.validation)
          }

        });

      }


    },
  }
}
</script>
<style>

.multi-cards-footer {
  margin-top: -35px !important;
}

.page-form-footer > button:not(:last-child), .page-form-footer > div:not(:last-child) {
  margin-right: .5rem !important
}

.form-validation .TextInput {
  padding-right: 5px;
  padding-left: 5px;
}

.tab-pane > .card {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.mode-tabs {
  border: none !important;
}

.mode-card > .card-body {
  padding-left: 2rem;
  padding-right: 2rem;
}

.mode-card .form-control {
  margin-bottom: 0.5rem !important;
}

.mode-card:not(:last-child) {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.mode-tabs > .card-body {
  padding: 0px;
}

.header-buttons .btn {
  margin: 0px;
}

.container_loading_form_card .gradient {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
  background-size: 1000px 640px;

  position: relative;

}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}
</style>
